// prettier-ignore
export interface CoreMenuItem {
	id: string;
	title: string;
	url?: string;
	type: 'section' | 'collapsible' | 'item';
	role?: Array<string>;
	translate?: string;
	icon?: string;
	disabled?: boolean;
	hidden?: boolean;
	classes?: string;
	exactMatch?: boolean;
	externalUrl?: boolean;
	openInNewTab?: boolean;
	badge?: ReleaseNote;
	children?: CoreMenuItem[];
	control?: string[];
};

export interface ReleaseNote {
	title?: string;
	translate?: string;
	classes?: string;
	notes?: string[];
}